import * as React from "react"

export const Footer: React.FunctionComponent = (props) => {

    return(
        <div className="FooterCard">
            <div className="FooterText FooterMarginTop">Laurence Brun tél: 06.58.92.50.53</div>
            <div className="FooterText">Dispensé d'immatriculation au registre du commerce (RCS) et au répertoire des métiers (RM) SIRET: 800 743 122 00023</div>
            <div className="FooterText">Site hébergé par OVH 2 rue Kellermann 59100 Roubaix - France</div>
            <div className="FooterFlex">
                <div className="FooterFlexFirst"><a href="https://www.en-deuil-et.com/index.php?">En deuil et...</a></div>
                <div className="FooterFlexLast">Développé par <a href="https://freelance.johanbrun.ovh/">Johan Brun</a></div>
            </div>
        </div>
    )
}